<svg [lucideIcon]="icon()" [size]="resolvedSize()" [strokeWidth]="1.5"></svg>
